import axios from '@/api/config';

const distributionLevel = {
  getDistributionLevelById(data) {
    return axios.get(`${process.env.BASE_URL}/distributionLevel/getDistributionLevel/` + data, {});
  },
  getDistributionLevelDetail(data) {
    return axios.get(`${process.env.BASE_URL}/distributionLevel/getDistributionLevelDetail`, {params: data});
  },
  getDistributionLevel(data) {
    return axios.get(`${process.env.BASE_URL}/distributionLevel/getDistributionLevel`, {params: data});
  },
  getDistributionLevelList(data) {
    return axios.get(`${process.env.BASE_URL}/distributionLevel/getDistributionLevelList`, {params: data});
  },
  getDistributionLevelTree(data) {
    return axios.get(`${process.env.BASE_URL}/distributionLevel/getDistributionLevelTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/distributionLevel/pageList`, data);
  },
  addDistributionLevel(data) {
    return axios.post(`${process.env.BASE_URL}/distributionLevel/addDistributionLevel`, data);
  },
  updateDistributionLevel(data) {
    return axios.put(`${process.env.BASE_URL}/distributionLevel/updateDistributionLevel`, data);
  },
  deleteDistributionLevel(data) {
    return axios.delete(`${process.env.BASE_URL}/distributionLevel/deleteDistributionLevel`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/distributionLevel/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/distributionLevel/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/distributionLevel/active`, data);
  },
}

export default distributionLevel;



// WEBPACK FOOTER //
// ./src/api/distributionLevel.js